// "use client";
import Lottie from "lottie-react";

import skillAnimation from "./skill.json";
const SkillImage = () => {
  return (
    <div>
      <Lottie
        animationData={skillAnimation}
        loop={true}
        style={{ width: "100%", height: "100%" }}
      />
    </div>
  );
};

export default SkillImage;
